import React, { useState } from 'react';

import Modal from 'components/Container/HelpUser/components/Modal';
import { sendHelpData, SUBJECT_OPTIONS } from 'components/Container/HelpUser/service';
import { HelpData } from 'components/Container/HelpUser/types';
import Toast from 'components/Shared/Toast';

import * as S from './styles';
import { Col, Row, Typography } from 'antd';

interface ContactProps {
  eventId: string;
  name: string;
  email: string;
}

const { Text } = Typography;

const Contact = ({ eventId, name, email }: ContactProps) => {
  const [openModal, setOpenModal] = useState(false);
  const [loadingModal, setLoadingModal] = useState(false);

  const handleSubmitData = (helpData: HelpData): void => {
    setLoadingModal(true);
    sendHelpData(helpData, eventId).subscribe({
      next: () => {
        setLoadingModal(false);
        setOpenModal(false);
        Toast.show('Sua mensagem foi enviada com sucesso');
      },
      error: () => {
        setLoadingModal(false);
        setOpenModal(false);
        Toast.error('Erro de comunicação. Recarregue a página');
      },
    });
  };

  return (
    <>
      <Col>
        <Row>
          <Text>Ficou com alguma dúvida?</Text>
        </Row>
        <Row>
          <Text>Envie uma mensagem para o produtor do evento.</Text>
        </Row>
      </Col>

      <Col>
        <S.CustomizedButton onClick={() => setOpenModal(true)}>Entre em contato</S.CustomizedButton>
      </Col>

      {openModal && (
        <Modal
          handleClose={() => setOpenModal(false)}
          onSubmit={handleSubmitData}
          open={openModal}
          loading={loadingModal}
          subjects={SUBJECT_OPTIONS}
          name={name}
          email={email}
        />
      )}
    </>
  );
};

export default Contact;
